// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2VMkA","disabled":"FileBtn_disabled__3bC7F","warn":"FileBtn_warn__2ulYy","fade":"FileBtn_fade__1UJ1j"};